import { H2, H3 } from '@/components/Titles';
import React from 'react';
import styled from 'styled-components';

const DecimalList = styled.ol`
  word-break: break-all;
  padding-left: 40px;
  > li {
    padding-left: 10px;
    list-style: decimal;
  }
`;
const LowerRomanList = styled.ol`
  word-break: break-all;
  padding-left: 40px;
  > li {
    padding-left: 10px;
    list-style: lower-roman;
  }
`;
const NumberDecimalList = styled.ol`
  word-break: break-all;
  padding-left: 40px;
  > li {
    padding-left: 10px;

    :nth-child(1) {
      list-style-type: '1.';
    }
    :nth-child(2) {
      list-style-type: '2.';
    }
    :nth-child(3) {
      list-style-type: '3.';
    }
    :nth-child(4) {
      list-style-type: '4.';
    }
    :nth-child(5) {
      list-style-type: '5.';
    }
    :nth-child(6) {
      list-style-type: '6.';
    }
    :nth-child(7) {
      list-style-type: '7.';
    }
    :nth-child(8) {
      list-style-type: '8.';
    }
    :nth-child(9) {
      list-style-type: '9.';
    }
    :nth-child(10) {
      list-style-type: '10.';
    }
  }
`;
const RoundDecimalList = styled.ol`
  word-break: break-all;
  padding-left: 40px;
  > li {
    padding-left: 10px;

    :nth-child(1) {
      list-style-type: '①';
    }
    :nth-child(2) {
      list-style-type: '②';
    }
    :nth-child(3) {
      list-style-type: '③';
    }
    :nth-child(4) {
      list-style-type: '④';
    }
    :nth-child(5) {
      list-style-type: '⑤';
    }
    :nth-child(6) {
      list-style-type: '⑥';
    }
    :nth-child(7) {
      list-style-type: '⑦';
    }
    :nth-child(8) {
      list-style-type: '⑧';
    }
    :nth-child(9) {
      list-style-type: '⑨';
    }
  }
  ${NumberDecimalList} {
    margin: 8px 0 0 0;
    padding-left: 16px;
    > li {
      padding-left: 10px;
    }
  }
`;
const AgreeSection = styled.div`
  line-height: 1.7;
  margin-top: 40px;
  ${H2} {
    margin-bottom: 20px;
  }
  ${H3} {
    margin-bottom: 16px;
  }
`;
const AgreeContents = styled.div`
  word-break: break-all;
  strong {
    display: block;
    margin-bottom: 16px;
  }
  p + p {
    margin-top: 4px;
  }
`;
const Table = styled.table`
  th,
  td {
    word-break: break-word;
  }
`;

// TODO 들여쓰기 적용하기
export const HomepageAgreeContent = (
  <>
    <H2
      css={`
        text-align: center;
      `}
    >
      이용약관
    </H2>
    <AgreeSection>
      <H3>제1장 총칙</H3>
      <AgreeContents>
        <strong>제 1조 (목적)</strong>
        <p>
          본 약관은 사단법인 유니세프 한국위원회(“위원회”)가 관리 및 운영하는
          웹사이트(“웹사이트”)에서 이용자에게 제공하는 제반 서비스와 관련하여
          위원회와 이용자 간의 권리, 의무, 책임사항과 기타 필요한 사항을
          규정함을 목적으로 합니다.
        </p>
      </AgreeContents>
    </AgreeSection>
    <AgreeSection>
      <AgreeContents>
        <strong>제2조 (정의)</strong>
        <p>본 약관에서 사용하는 용어의 정의는 다음과 같습니다.</p>
        <p>
          <NumberDecimalList>
            <li>
              “서비스”라 함은 구현되는 단말기와 관계없이 “웹사이트”에서 이용할
              수 있는 일체 서비스를 의미합니다.
            </li>
            <li>
              “이용자”라 함은 “웹사이트”에 접속하여 제공되는 “서비스”를 이용하는
              개인, 단체 또는 법인을 의미합니다.
            </li>
            <li>
              “회원”이라 함은 “웹사이트”에서 본 약관에 따라 “계정”과
              “비밀번호”를 생성하여 등록하거나 자신의 SNS 계정으로 로그인하여
              “서비스”를 이용할 수 있는 개인, 단체 또는 법인을 의미합니다.
            </li>
            <li>
              “계정”, “ID” 또는” 아이디”라 함은 회원의 식별 등을 위하여 “회원”이
              선정하고 “웹사이트”에서 부여하는 문자와 숫자 등의 조합을
              의미합니다.
            </li>
            <li>
              “비밀번호”라 함은 회원과 “계정”이 일치하는지 여부를 확인하고
              통신상 비밀보호를 위하여 “회원”이 선정한 문자와 숫자 등의 조합을
              의미합니다.
            </li>
            <li>
              “후원회원”이라 함은 “위원회” 활동을 지원하기 위하여 반대급부 없이
              정기적 또는 비정기적으로 동산(금전, 유가증권, 기타 물건 포함) 및
              부동산 등 재산을 기부하는 개인, 단체 또는 법인을 의미합니다.
            </li>
            <li>
              “콘텐츠”라 함은 “웹사이트”에 게시된 모든 이미지, 삽화, 영상,
              텍스트, 오디오 등의 정보 형태의 글, 사진, 동영상 및 각종 파일과
              링크를 의미합니다.
            </li>
          </NumberDecimalList>
        </p>
      </AgreeContents>
    </AgreeSection>
    <AgreeSection>
      <AgreeContents>
        <strong>제3조 (약관의 효력 및 변경)</strong>
        <p>
          <RoundDecimalList>
            <li>
              “위원회”는 본 약관의 내용을 “이용자”가 쉽게 알 수 있도록
              “웹사이트” 초기화면에 게시하거나 초기화면에 링크를 생성하여
              제공합니다.
            </li>
            <li>
              “위원회”는 「약관의 규제에 관한 법률」, 「개인정보 보호법」 등
              관련법령을 위반하지 않는 범위에서 본 약관을 변경할 수 있습니다.
            </li>
            <li>
              “위원회”가 본 약관을 변경하고자 할 때에는 그 시행일 15일 전에
              변경된 약관의 적용일자와 변경 사유, 변경 내용을 명시하여
              “웹사이트”의 초기화면 또는 초기화면에서 링크된 화면에 게시합니다.
              다만 “회원”에게 불리한 약관 변경인 경우 최소한 30일 이상의 기간을
              두고 게시하고 필요에 따라 전자적 수단을 통해 이용자에게 별도로
              통지합니다.
            </li>
            <li>
              “회원”이 제3항의 약관 변경에 동의하지 않는 경우 회원등록을 해지할
              수 있으며, 변경된 약관의 시행일로부터 7일 이내에 거부의사를
              표시하지 않은 경우 약관 변경에 동의한 것으로 간주합니다.
            </li>
          </RoundDecimalList>
        </p>
      </AgreeContents>
    </AgreeSection>
    <AgreeSection>
      <H3>제2장 회원</H3>
      <AgreeContents>
        <strong>제4조 (이용계약)</strong>
        <p>
          <RoundDecimalList>
            <li>
              이용계약은 “이용자”의 본 약관에 대한 동의 및 이용신청과 이에 대한
              “위원회”의 이용승낙으로 성립합니다.
            </li>
            <li>
              “이용자” 중에 “회원”이 되고자 하는 자는 본 약관의 내용에 동의하고
              성명 등 본인의 개인정보를 제공하여 회원등록을 해야 합니다.
            </li>
            <li>
              “위원회”는 다음 각 호의 경우 회원등록을 취소하거나 해당 사유가
              해소될 때까지 이용을 제한할 수 있습니다.
              <NumberDecimalList>
                <li>
                  본인 아닌 다른 개인, 단체 또는 법인의 명의를 도용한 경우
                </li>
                <li>
                  허위의 정보를 기재하거나 요구되는 정보를 제공하지 않은 경우
                </li>
                <li>14세 미만 아동이 법정대리인의 동의를 얻지 않은 경우</li>
                <li>영리. 기타 부정한 목적으로 “서비스”를 이용한 경우</li>
                <li>“웹페이지” 운영 및 “서비스” 제공 등을 방해한 경우</li>
                <li>“위원회”의 명예를 현저히 훼손하는 행위를 한 경우</li>
                <li>
                  공공질서 및 미풍양속에 위반되는 내용을 유포하거나 링크시킨
                  경우
                </li>
                <li>
                  기타 관계법령에 위배되는 등 “회원”으로서 자격을 유지하기
                  어렵다고 판단되는 경우
                </li>
              </NumberDecimalList>
            </li>
          </RoundDecimalList>
        </p>
      </AgreeContents>
    </AgreeSection>
    <AgreeSection>
      <AgreeContents>
        <strong>제5조 (회원정보의 변경)</strong>
        <p>
          <RoundDecimalList>
            <li>
              “회원”의 “계정” 및 “비밀번호”에 대한 관리책임은 “회원”에게
              있습니다.
            </li>
            <li>
              “후원회원”이 회원등록을 한 경우 “웹사이트”에서 조회일
              기준시점으로부터 최근 2년까지의 후원 내역을 조회 및 출력할 수
              있습니다.
            </li>
            <li>
              “회원”은 본인의 “계정”과 “비밀번호”가 제3자에 의하여 사용되고
              있음을 인지하였을 때에는 이를 즉시 “위원회”에 통지하고 안내에
              따라야 합니다.
            </li>
            <li>
              “회원”은 회원등록시 기재한 사항이 변경되었을 경우 이를 수정하거나
              전자우편 등 방법으로 “위원회”에 알려야 합니다.
            </li>
            <li>
              “회원”이 제3항과 제4항을 따르지 않아 발생한 불이익에 대해
              “위원회”는 책임지지 않습니다.
            </li>
          </RoundDecimalList>
        </p>
      </AgreeContents>
    </AgreeSection>
    <AgreeSection>
      <H3>제3장 계약 당사자의 의무 </H3>
      <AgreeContents>
        <strong>제6조 (위원회의 의무)</strong>
        <p>
          <RoundDecimalList>
            <li>
              “위원회”는 특별한 사정이 없는 한 본 약관이 정하는 바에 따라
              “웹페이지”에서 “서비스”를 지속적, 안정적으로 제공하기 위하여
              노력할 의무가 있습니다.
            </li>
            <li>
              “위원회”는 “이용자”에게 가장 최신의 정보를 성실히 제공하며,
              “이용자”의 질문, 요청, 불만 제기 등에 대해 최대한 빠른 시일 내에
              응대합니다.
            </li>
            <li>
              “위원회”는 “이용자”로부터 제기되는 의견이나 불만사항이 객관적으로
              정당하다고 인정되는 경우에는 적절한 절차를 거쳐 이를 지체없이
              처리하여야 합니다.
            </li>
            <li>
              “위원회”는 “회원”의 개인정보를 보호하기 위하여 「개인정보 보호법」
              등 관계 법령이 정하는 바에 따라 개인정보처리방침을 공시하고
              준수합니다.
            </li>
            <li>
              “위원회”는 “서비스” 제공과 관련하여 수집된 개인정보를 본인의 사전
              승낙 없이 제3자에게 누설하지 않습니다. 다만 법률의 규정에 의하여
              국가기관의 요구가 있거나 범죄에 대한 수사상 목적이 있거나 그 밖에
              관계법령에서 정한 절차에 따른 요청이 있는 경우 그러하지 않습니다.
            </li>
          </RoundDecimalList>
        </p>
      </AgreeContents>
    </AgreeSection>
    <AgreeSection>
      <AgreeContents>
        <strong>제7조 (이용자의 의무)</strong>
        <p>
          <RoundDecimalList>
            <li>
              “이용자”는 본인의 “계정” 및 “비밀번호”에 대한 관리책임을 스스로
              부담하며, 그 관리를 소홀히 하여 발생하는 손해에 대해 “위원회”는
              책임을 지지 않습니다.
            </li>
            <li>
              “이용자”는 “위원회”의 사전 승낙 없이 “웹사이트” 또는 “서비스”를
              이용하여 영업행위를 하지 않으며, “위원회”는 다른 “이용자”와
              제3자에 대하여 일체 책임을 지지 않습니다.
            </li>
            <li>
              “이용자”는 본 약관이 규정하는 사항과 “서비스” 안내 및 공지사항,
              기타 관계법령 등을 준수하여야 합니다.
            </li>
            <li>
              “이용자”는 “위원회”의 권리를 침해하거나, 정상적인 업무를
              방해하거나, “위원회”의 이념과 윤리기준에 위배되거나 그 명예를
              훼손하는 행위를 해서는 안 됩니다.
            </li>
          </RoundDecimalList>
        </p>
      </AgreeContents>
    </AgreeSection>
    <AgreeSection>
      <H3>제4장 서비스 이용</H3>
      <AgreeContents>
        <strong>제8조 (서비스의 제공) </strong>
        <p>
          <RoundDecimalList>
            <li>
              “위원회”는 특별한 사정이 없는 한 연중무휴, 1일 24시간 지속적으로
              “서비스”를 제공합니다. 다만, 시스템 정기점검 등이 있는 경우 사전에
              기간 등을 공지하고 일시적으로 중단할 수 있습니다.
            </li>
            <li>
              “위원회”는 필요하다고 인정되는 경우 사전에 공지하고 “서비스”를
              분할하여 각 범위별로 이용가능시간을 달리 지정할 수 있습니다.
            </li>
            <li>
              “위원회”는 다음 각 호의 경우 “서비스”의 전부 또는 일부의 제공을
              중단할 수 있습니다.
              <NumberDecimalList>
                <li>
                  정보통신설비의 보수 점검, 증설 및 교체 등으로 인한 부득이한
                  경우
                </li>
                <li>기간통신사업자가 전기통신서비스를 중단한 경우</li>
                <li>
                  서비스 이용의 폭주 등으로 정상적인 서비스 제공에 지장이 있는
                  경우
                </li>
                <li>국가비상사태 등 불가항력적인 사유가 발생한 경우 </li>
                <li>
                  기타 불가피한 사유로 사전에 고지하고 “서비스” 제공을 중단하는
                  경우{` `}
                </li>
              </NumberDecimalList>
            </li>
            <li>
              “위원회”는 원칙적으로 “서비스”를 무료로 제공하되, “서비스”별로
              필요한 경우 “이용자” 또는 “회원”으로부터 별도 약관에 대한 동의를
              받아 유료로 제공할 수도 있습니다.
            </li>
          </RoundDecimalList>
        </p>
      </AgreeContents>
    </AgreeSection>
    <AgreeSection>
      <AgreeContents>
        <strong>제9조 (콘텐츠의 저작권)</strong>
        <p>
          <RoundDecimalList>
            <li>
              “위원회”가 “웹페이지”에서 제공하는 “콘텐츠”에 대한 지적재산권은
              별도의 저작권 표시 등이 없는 한 “위원회”에 귀속됩니다.{` `}
            </li>
            <li>
              “위원회”는 제3자로부터 사용을 허가 받은 컨텐츠의 경우 그 출처 또는
              저작권을 “웹사이트”에 명시합니다.{` `}
            </li>
            <li>
              “위원회”는 “콘텐츠”의 저작권 등 권리 침해가 발생하였다고 판단되는
              경우 손해배상을 청구하거나 그 밖에 제반 법적 조치를 취할 수
              있습니다.{` `}
            </li>
          </RoundDecimalList>
        </p>
      </AgreeContents>
    </AgreeSection>
    <AgreeSection>
      <AgreeContents>
        <strong>제10조 (콘텐츠 안내와 사용)</strong>
        <p>
          <RoundDecimalList>
            <li>
              “위원회”가 “웹페이지”에 표시한 국가의 명칭, 영토, 기관, 국경의
              경계에 대한 구분 등은 일반적인 구분에 따른 것일 뿐 “위원회”의 최종
              판단이 아닙니다.{` `}
            </li>
            <li>
              “위원회”는 “웹페이지”에 언급된 특정 회사 또는 제품에 대해
              추천하거나 보증하지 않으며, “웹사이트”의 링크를 통해 연결되는 외부
              웹사이트에서 제공되는 정보, 자료, 의견, 조언, 주장의 정확성과
              신뢰도 등에 대해서도 책임을 지지 않습니다.
            </li>
            <li>
              “이용자”가 “콘텐츠”를 개인적 정보 취득, 교육 목적 이외의 용도로
              모방, 번역, 인쇄물 제작, CD 편집, 그 밖에 전자미디어 등 다른
              방법으로 이용하고자 할 경우에는 “위원회”로부터 사전 서면 허가를
              받아야 합니다.{` `}
            </li>
            <li>
              “위원회”의 명칭(UNICEF, United Nations Children’s Fund, 유니세프,
              유엔아동기금 등을 포함)과 로고, 엠블럼 등은 어떠한 경우에도
              “위원회”로부터 사전에 서면 또는 전자우편을 통하여 승인을 받지 않고
              무단으로 사용할 수 없습니다.{` `}
            </li>
            <li>
              제3항의 사용 허락이 있을 때에도 “콘텐츠”의 임의 변형, 수정, 부분
              삭제 등 원본의 의미 전달이 훼손될 수 있는 행위를 해서는 안 됩니다.
              {` `}
            </li>
          </RoundDecimalList>
        </p>
      </AgreeContents>
    </AgreeSection>
    <AgreeSection>
      <AgreeContents>
        <strong>제11조 (게시물의 관리)</strong>
        <p>
          <RoundDecimalList>
            <li>
              “이용자” 또는 “회원”이 “웹사이트”에 게시한 게시물에 대한 저작권은
              해당 게시자에게 귀속되며, “위원회”는 게시물이 변조, 훼손, 삭제되지
              않도록 최선을 다해 보호합니다.
            </li>
            <li>
              “위원회”는 다음 각 호의 경우 사전 통지 없이 “이용자”가 게시한
              게시물을 삭제하거나 등록 거부할 수 있으며, 게시자의 “회원” 자격을
              제한, 정지 또는 상실시킬 수 있습니다.
              <NumberDecimalList>
                <li>
                  다른 “이용자”, “회원” 또는 제3자에게 모욕을 주거나 명예를
                  훼손하는 경우
                </li>
                <li>“위원회” 또는 제3자의 저작권 등 권리를 침해하는 경우</li>
                <li>영리를 목적으로 하는 광고인 경우 </li>
                <li>불법복제 및 해킹을 조장하는 경우</li>
                <li>범죄적 행위에 결부된다고 인정되는 경우 </li>
                <li>타인의 성명 등을 무단으로 도용한 경우</li>
                <li>동일한 내용을 중복하여 과도하게 다수 게시하는 경우 </li>
                <li>
                  “위원회”에서 규정한게시 원칙에 어긋나거나 게시판 성격에
                  부합하지 않는 경우
                </li>
                <li>
                  공공질서 및 미풍양속에 위반되는 내용을 유포하거나 링크시키는
                  경우{` `}
                </li>
                <li>기타 관계법령에 위배되는 것으로 인정되는 경우</li>
              </NumberDecimalList>
            </li>
          </RoundDecimalList>
        </p>
      </AgreeContents>
    </AgreeSection>
    <AgreeSection>
      <AgreeContents>
        <strong>제12조 (광고 게재)</strong>
        <p>
          <RoundDecimalList>
            <li>
              “웹페이지”에는 “위원회”와 광고주 간의 계약관계 등에 따라 배너와
              링크를 포함하는 다양한 광고가 게재될 수 있으며, “이용자”는
              “서비스” 이용 시 광고 게재에 동의하는 것으로 봅니다.{` `}
            </li>
            <li>
              “위원회”는 제1항의 광고와 관련하여 “이용자”가 광고주와 교신하거나
              거래하는 결과로서 발생한 손실 및 손해에 대하여 어떠한 책임도 지지
              않습니다.{` `}
            </li>
          </RoundDecimalList>
        </p>
      </AgreeContents>
    </AgreeSection>
    <AgreeSection>
      <AgreeContents>
        <strong>제13조 (정보의 제공)</strong>
        <p>
          <RoundDecimalList>
            <li>
              “위원회”는 “서비스”에 관한 정보를 제공하거나 후원 장려, 이벤트
              안내 등을 위하여 “웹페이지”의 게시판 또는 전자우편, SMS 발송 등을
              통하여 “회원”에게 메시지를 전달할 수 있습니다. 이때 “위원회”는
              「개인정보처리방침」을 준수합니다.
            </li>
            <li>
              “회원”은 “웹페이지”에서 정보 수신 동의 또는 부동의를 통해
              “위원회”가 “회원”의 전자우편, SMS 등으로 발송하는 내용물의 수신을
              거부할 수 있습니다.{` `}
            </li>
          </RoundDecimalList>
        </p>
      </AgreeContents>
    </AgreeSection>
    <AgreeSection>
      <H3>제5장 계약해지</H3>
      <AgreeContents>
        <strong>제14조 (회원등록 해지)</strong>
        <p>
          <RoundDecimalList>
            <li>
              “회원”이 이용계약을 해지하고자 하는 경우에는 “회원” 본인이
              “웹사이트”에서 탈퇴신청을 할 수 있습니다.{` `}
            </li>
            <li>
              “후원회원”이 본 약관에 따른 이용계약 이외에 별도로 후원계약을
              해지하고자 하는 경우에는 「후원약관」에 규정된 절차에 따라 전화
              등을 통해 “위원회”에 후원탈퇴 의사를 밝혀야 합니다.{` `}
            </li>
            <li>
              제1항 및 제2항의 경우 “위원회”는 「개인정보처리방침」 및
              관련법령에 의거하여 개인정보를 일정기간 보유하거나 폐기합니다.
            </li>
            <li>
              “위원회”는 “회원”이 제4조 제3항 각호, 제7조, 제9조 제1항, 제10조
              제4항, 제11조 제2항 각호의 내용을 위반한 경우 해당 “회원”의 등록을
              해지할 수 있습니다.{` `}
            </li>
          </RoundDecimalList>
        </p>
      </AgreeContents>
    </AgreeSection>
    <AgreeSection>
      <H3>제6장 분쟁의 해결 및 기타</H3>
      <AgreeContents>
        <strong>제15조 (면책) </strong>
        <p>
          <RoundDecimalList>
            <li>
              “위원회”는 본 이용약관에 따른 “서비스” 제공과 관련하여 다음 각
              호의 경우 책임이 면제됩니다.
              <NumberDecimalList>
                <li>
                  천재지변, 전쟁, 기타 불가항력적인 사유로 “서비스”를 제공할 수
                  없는 경우{` `}
                </li>
                <li>기간통신사업자가 전기통신서비스를 중단한 경우</li>
                <li>
                  설비의 보수, 교체, 점검, 공사 등 부득이한 사유로 “서비스”
                  제공이 중단된 경우
                </li>
                <li>“회원”의 귀책사유로 “서비스” 이용에 장애가 발생한 경우 </li>
                <li>
                  “회원”이 개인정보, 기타 정보를 잘못 기재하여 손해가 발생한
                  경우
                </li>
                <li>
                  “이용자” 간 또는 “이용자”와 제3자 간 거래 등으로 분쟁이 발생한
                  경우{` `}
                </li>
                <li>
                  “위원회” 아닌 서비스 제공자가 계약관계 등에 따라
                  “웹사이트”에서 제공하는 개별 서비스와 관련하여 분쟁이 발생한
                  경우{` `}
                </li>
                <li>
                  그 밖에 본 약관, 관계법령에 따라 “위원회”의 책임이 아닌 경우
                  {` `}
                </li>
              </NumberDecimalList>
            </li>
            <li>
              “위원회”는 무료로 제공되는 “서비스”의 이용과 관련하여 “위원회”의
              고의 또는 중과실로 인한 경우가 아닌 한 손해에 대하여 책임을 지지
              않습니다.
            </li>
          </RoundDecimalList>
        </p>
      </AgreeContents>
    </AgreeSection>
    <AgreeSection>
      <AgreeContents>
        <strong>제16조 (약관의 해석 등)</strong>
        <RoundDecimalList>
          <li>
            본 약관은 “서비스”에 따른 별도 약정, “위원회” 정관 및 제규정과 함께
            적용됩니다.
          </li>
          <li>
            본 약관에 명시되지 아니한 사항 및 그 해석에 관하여 관계법령 또는
            상관례에 따릅니다.
          </li>
        </RoundDecimalList>
      </AgreeContents>
    </AgreeSection>
    <AgreeSection>
      <AgreeContents>
        <strong>제17조 (분쟁의 해결) </strong>
        <RoundDecimalList>
          <li>
            “위원회”와 “이용자” 또는 “회원” 간에 이용계약과 관련하여 분쟁이
            발생한 경우 상호 원만한 소통을 통해 해결하기 위하여 최선의 노력을
            기울여야 합니다.{` `}
          </li>
          <li>
            제1항에 따라 분쟁이 우호적으로 해결되지 않아 소송이 제기되는 경우
            법령에 절차에 따른 법원을 관할 법원으로 합니다.
          </li>
        </RoundDecimalList>
      </AgreeContents>
    </AgreeSection>
  </>
);

// 회원가입 개인정보 수집,이용 동의
export const JoinPrivacyAgreeContent = (
  <>
    <Table
      summary="개인정보 수집∙이용 동의"
      cellPadding="0"
      cellSpacing="0"
      style={{ tableLayout: `fixed` }}
    >
      <caption>개인정보 수집∙이용 동의</caption>
      <colgroup>
        <col width="25%" />
        <col width="*" />
        <col width="25%" />
      </colgroup>
      <thead>
        <tr>
          <th>목적</th>
          <th>항목</th>
          <th>보유 기간</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            회원∙후원 상담, 관리,
            <br />
            긴급구호, 후원장려,
            <br />
            소식지 및 서비스 제공
          </td>
          <td>성명, 아이디, 비밀번호, 전화번호, 이메일, 생년월일</td>
          <td>
            <span className="cyanblue">웹회원 탈퇴시까지</span>
          </td>
        </tr>
      </tbody>
    </Table>
    <div className="info">
      * 위의 개인정보 수집∙이용에 대한 동의를 거부할 권리가 있으나, 동의를
      거부할 경우 회원가입이 불가합니다.
    </div>
  </>
);

// 후원신청 개인정보 수집,이용 동의
export const SupportPrivacyAgreeContent = (
  <>
    <Table
      summary="개인정보 수집 ∙ 이용 동의"
      cellPadding="0"
      cellSpacing="0"
      style={{ tableLayout: `fixed` }}
    >
      <caption>개인정보 수집 ∙ 이용 동의</caption>
      <colgroup>
        <col width="30%" />
        <col width="*" />
        <col width="30%" />
      </colgroup>
      <thead>
        <tr>
          <th>목적</th>
          <th>항목</th>
          <th>보유 기간</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td className="left">
            회원∙후원 상담, 관리,
            <br />
            긴급구호, 후원장려,
            <br />
            소식지 및 서비스 제공
          </td>
          <td className="left">성명, 전화번호, 이메일, 주소, 생년월일</td>
          <td className="left" rowSpan={3}>
            법정 보존기간을 준수하여 정보주체의 처리 정지 요청 시까지
          </td>
        </tr>
        <tr>
          <td className="left">
            기부금 영수증 발급 및<br />
            연말정산 간소화 서비스 등록
          </td>
          <td className="left">
            성명, <b>주민등록번호</b>, 주소, 전화번호, 이메일
            <br />* 소득세법 제160조의3, 법인세법제112조의2에 따라 국세청에
            제공합니다.
          </td>
        </tr>
        <tr>
          <td className="left">카드결제 또는 계좌자동이체 후원</td>
          <td className="left">
            (카드결제의 경우) 성명, 카드사, 카드번호, 유효기간, 생년월일
            <br />
            (계좌자동이체의 경우) 성명, 은행, 계좌번호, 생년월일
          </td>
        </tr>
      </tbody>
    </Table>
    <div style={{ marginTop: `20px` }}>
      * 위의 개인정보 수집∙이용에 대한 동의를 거부할 권리가 있으나, 동의를
      거부할 경우 후원신청이 불가합니다.
    </div>
  </>
);

// 후원약관
export const SupportAgreeContent = (
  <>
    <br />
    <strong>제1조 (목적)</strong>
    <br />
    <br />본 약관은 사단법인 유니세프 한국위원회(“위원회”)가
    유엔아동권리협약(United Nations Convention on the Rights of the Child) 및
    정관에 의거하여 전개하는 제반 활동 및 사업 등을 지원하기 위한 후원과
    관련하여 위원회와 후원회원 간의 권리, 의무, 책임사항과 기타 필요한 사항을
    규정함을 목적으로 합니다.
    <br />
    <br />
    <strong>제2조 (정의)</strong>
    <br />
    <br />이 약관에서 사용하는 용어의 정의는 다음과 같습니다.
    <br />
    <br />
    <DecimalList>
      <li>
        “후원”이라 함은 “위원회”의 고유한 업무를 지원하기 위하여 반대급부 없이
        정기적 또는 비정기적으로 동산(금전, 유가증권, 기타 물건 포함), 부동산 등
        재산을 “위원회”에 기부하는 행위를 의미합니다.
      </li>
      <li>
        “후원회원” 또는 “후원자”라 함은 “위원회”에 “기부재산”을 “후원”하는 개인,
        단체 또는 법인을 의미합니다.
      </li>
      <li>
        “정기후원”이라 함은 월 단위로 지정된 결제수단에 의하여 일정한 금액을
        “위원회”에 기부하는 “후원”을 의미합니다. “정기후원”하는 “후원회원”을
        “정기후원자”라고 합니다.
      </li>
      <li>
        “비정기후원” 또는 “일시후원”이라 함은 일시 또는 수시로 일정한 금액을
        “위원회”에 기부하는 “후원”을 의미합니다. “비정기후원”하는 “후원회원”을
        “비정기후원자”라고 합니다.
      </li>
      <li>
        “기부재산”이라 함은 “후원회원”이 “위원회”에 “후원”하는 동산(후원금
        포함), 부동산 등 재산을 의미합니다.
      </li>
    </DecimalList>
    <br />
    <strong>제3조 (약관의 효력 및 변경)</strong>
    <br />
    <br />
    <RoundDecimalList>
      <li>
        “위원회”는 후원계약을 체결할 때에 “후원회원”에게 약관의 주요 내용을 알기
        쉽게 설명하고, “후원회원”이 요구할 경우 본 약관의 사본을 서면, 전자우편
        등 방법으로 “후원회원”에게 제공합니다.
      </li>
      <li>
        “위원회”는 본 약관의 내용을 “후원회원”이 쉽게 알 수 있도록 “위원회”가
        관리 및 운영하는 웹사이트 초기화면에 게시하거나 초기화면에 링크를
        생성하여 제공합니다.
      </li>
      <li>
        “후원회원”이 “위원회”와 사이에 유산기부, 사회공헌협약 등 개별 후원
        약정을 체결한 경우 해당 약정이 본 약관에 우선하여 적용됩니다.
      </li>
      <li>
        “위원회”는 「약관의 규제에 관한 법률」, 「개인정보 보호법」 등
        관련법령을 위반하지 않는 범위에서 본 약관을 변경할 수 있습니다.
      </li>
      <li>
        “위원회”가 본 약관을 변경하고자 할 때에는 그 시행일 15일 전에 변경된
        약관의 적용일자와 변경 사유, 변경 내용을 명시하여 “위원회”가 관리 및
        운영하는 웹사이트의 초기화면 또는 초기화면에서 링크된 화면에 게시합니다.
      </li>
      <li>
        제5항에 불구하고 “후원회원”에게 불리한 약관 변경인 경우 최소한 30일
        이상의 기간을 두고 게시하고, 전자우편 등 전자적 수단을 통해
        “후원회원”에게 별도로 통지합니다.
      </li>
      <li>
        “회원”이 제5항의 약관 변경에 동의하지 않는 경우 후원을 중단 또는 해지할
        수 있으며, 변경된 약관의 시행일로부터 7일 이내에 거부의사를 표시하지
        않고 1회 이상 “후원”한 경우 약관 변경에 동의한 것으로 간주합니다.
      </li>
    </RoundDecimalList>
    <br />
    <br />
    <strong>제4조 (후원계약의 성립)</strong>
    <br />
    <br />
    <RoundDecimalList>
      <li>
        후원계약은 “후원회원”의 후원신청 및 본 약관에 대한 동의와 이에 대한
        “위원회”의 승낙으로 성립합니다.
      </li>
      <li>
        본 약관에 동의는 “후원회원”이 후원신청시 서면, 전자우편, 전화통화 등으로
        본 약관에 대한 동의를 표시함으로써 이루어집니다.
      </li>
      <li>
        만 19세에 이르지 않은 미성년자가 본인의 이름으로 “후원”하고자 하는 경우
        부모 등 법정대리인의 개인정보 제공과 후원신청에 대한 동의가 필요합니다.
      </li>
      <li>
        “후원회원”은 후원신청시 “위원회”가 요구하는 일정한 개인정보를 제공하여야
        하며, 제공된 개인정보는 “위원회”의 「개인정보처리방침」 및 관련법령에
        따라 엄격하게 관리, 보호됩니다.
      </li>
      <li>
        부모 등 법정대리인이 미성년자인 자녀 등의 이름으로 “후원”하고자 하는
        경우 “위원회”는 해당 미성년자의 개인정보 이외에 법정대리인의 개인정보를
        요구할 수 있습니다.
      </li>
      <li>
        후원신청자 명의와 은행계좌, 신용카드 등의 명의가 불일치하는 경우
        “위원회”는 후원신청자 이외에 해당 은행계좌, 신용카드 등의 명의자의
        개인정보를 요구할 수 있습니다.
      </li>
      <li>
        “후원회원”이 단체 또는 법인인 경우 “위원회”는 영수증 발급 등을 위한
        목적으로 담당자 개인정보와 단체 또는 법인의 사업자등록번호, 고유번호,
        임·직원 기부 시 해당 개인들의 개인정보 등을 요구할 수 있습니다.
      </li>
    </RoundDecimalList>
    <br />
    <br />
    <strong>제5조 (후원계약의 취소 등)</strong>
    <br />
    <br />
    “위원회”는 다음 각 호의 1의 경우 후원신청을 거부하거나 후원계약을 취소 또는
    해당 사유가 해소될 때까지 “후원” 수령을 거부할 수 있습니다.
    <br />
    <br />
    <DecimalList>
      <li>
        후원신청시 허위의 정보를 기재하거나 요구되는 정보를 제공하지 않은 경우
      </li>
      <li>만 19세 미만 아동이 법정대리인의 동의를 얻지 않고 후원신청한 경우</li>
      <li>“위원회”의 명예를 현저히 훼손하는 행위를 한 경우</li>
      <li>공공질서 및 미풍양속에 위반되는 목적으로 후원하고자 하는 경우</li>
      <li>기타 “위원회”와 유니세프 본사의 정책 및 관계법령에 위배되는 경우</li>
    </DecimalList>
    <br />
    <br />
    <strong>제6조 (정기후원의 방법)</strong>
    <br />
    <br />
    <RoundDecimalList>
      <li>
        “후원회원”은 후원신청시 자동이체 계좌, 신용카드 등 결제수단 정보를
        제공함으로써 “정기후원”에 참여할 수 있습니다.
      </li>
      <li>
        “정기후원” 신청 시 “후원회원”이 지정하거나 “위원회”가 안내한 날짜에
        맞추어 제공된 결제 수단으로 “정기후원” 금액이 청구되며, 결제가
        정상적으로 이루어지지 않은 경우 재청구할 수 있습니다.
      </li>
      <li>
        “정기후원”은 특별한 사유가 없는 한 “후원회원”이 후원중단 또는 후원계약에
        대한 해지의 의사표시를 할 때까지 유지됩니다.
      </li>
    </RoundDecimalList>
    <br />
    <br />
    <strong>제7조 (비정기후원의 방법)</strong>
    <br />
    <br />
    <RoundDecimalList>
      <li>
        “후원회원”은 웹사이트, 모금사이트를 통한 온라인 결제, “위원회” 명의의
        공개된 “일시후원” 계좌에의 송금, 직접 전달, 기타 플랫폼을 통한 송금
        등으로 “위원회”에 “비정기후원”에 참여할 수 있습니다.
      </li>
      <li>
        “후원회원”은 “비정기후원”에서 “정기후원”으로 변경할 수 있으며, 이 경우
        “위원회”로부터 추가 개인정보의 제공 등을 요청받을 수 있습니다. 이때 해당
        “비정기후원자”는 변경 절차가 완료되는 시점부터 “정기후원자”인 것으로
        봅니다.
      </li>
    </RoundDecimalList>
    <br />
    <br />
    <strong>제8조 (기부재산의 사용 등)</strong>
    <br />
    <br />
    <RoundDecimalList>
      <li>
        “위원회”는 “후원회원”들로부터 제공받은 “기부재산”을 “위원회”의
        설립목적과 사업계획 등에 따라 합법적이고 공정하며 투명한 절차와 방법으로
        사용하고, “위원회”가 관리 및 운영하는 웹사이트, 회원소식지 등을 통하여
        사업의 내용 등을 정기적으로 공개합니다.
      </li>
      <li>
        “후원회원”이 목적을 지정하여 제공한 “기부재산”은 지정된 목적에 따라
        사용하되, 구체적 운용방식 및 보고 등은 별도 합의에 따릅니다.
      </li>
      <li>
        “위원회”는 금전 이외의 “기부재산”에 대하여 필요한 경우 이를 매각 등
        처분하여 사용할 수 있습니다.
      </li>
      <li>
        상속재산 중 피상속인이나 상속인이 상속세 과세표준신고 기한까지
        “위원회”에 제공한 “기부재산”의 가액은 상속세 과세가액에 산입하지
        아니합니다.
      </li>
      <li>
        부동산 기부의 경우 “위원회”로의 소유권 이전으로 인한 취득세, 등록세,
        이후 처분으로 인한 양도소득세 등 관련 법령에 따라 과세될 수 있습니다.
      </li>
    </RoundDecimalList>
    <br />
    <br />
    <strong>제9조 (위원회의 의무)</strong>
    <br />
    <br />
    <RoundDecimalList>
      <li>
        “위원회”는 “후원회원”과 합의한 날짜로부터 “후원”이 정상적으로 이루어질
        수 있도록 처리합니다.
      </li>
      <li>
        “위원회”는 “후원회원”이 불만을 제기하거나 개인정보 변경 등을 요청하는
        경우 이를 검토하고, 필요하다고 인정되면 적절한 절차를 거쳐 지체없이
        처리하며, 처리 결과를 해당 “후원회원”에게 통보합니다.
      </li>
      <li>
        “위원회”는 “후원회원”에 대한 서비스를 원만하게 처리하고 품질을 향상하기
        위하여 적절한 조치를 취합니다.
      </li>
      <li>
        “위원회”는 “후원회원”이 제공한 개인정보를 「개인정보 보호법」 등
        관련법령에 따라 엄격하게 관리 및 보호합니다.
      </li>
    </RoundDecimalList>
    <br />
    <br />
    <strong>제10조 (후원회원의 의무)</strong>
    <br />
    <br />
    <RoundDecimalList>
      <li>
        “후원회원”은 후원신청 및 개인정보 변경시 실명으로 모든 사항을 사실에
        근거하여 제공하여야 하며, 허위 또는 타인의 정보를 무단으로 등록할 경우
        “후원회원”으로서 권리를 “위원회”에 대하여 주장하지 못할 수도 있습니다.
      </li>
      <li>
        “후원회원”은 주소, 연락처 등 본인의 개인정보를 관리할 책임이 있으며,
        “위원회”는 “후원회원”이 개인정보 변경 등을 통지하지 않아 발생한 불이익에
        대하여 책임을 지지 않습니다.
      </li>
      <li>
        “후원회원”은 본 약관에서 규정하는 사항과 그 밖에 관계법령을 준수하며,
        “위원회”의 업무를 방해하거나 그 명예를 훼손하는 행위를 하지 않습니다.
      </li>
      <li>
        “후원회원”은 “위원회”로부터 사전 동의를 받지 않고 “위원회”의 브랜드 및
        로고 등을 이용할 수 없으며, “위원회”는 그 결과에 대해 일체 책임을 지지
        않고 “위원회”가 손해를 입을 경우 해당 “후원회원”에게 손해배상을 청구할
        수 있습니다.
      </li>
      <li>
        “후원회원”은 “위원회”의 운영진, 직원, 기타 이해관계자를 사칭하는 행위를
        하지 않습니다.
      </li>
    </RoundDecimalList>
    <br />
    <br />
    <strong>제11조 (기타 서비스)</strong>
    <br />
    <br />
    <RoundDecimalList>
      <li>
        “위원회”는 “후원회원”에게 “위원회”의 활동 및 사업 내용을 정기적으로
        투명하게 공개합니다.
      </li>
      <li>
        “위원회”는 “위원회”의 활동에 관한 정보를 제공하고 “후원” 기회 등에 관해
        안내하기 위하여 전자우편 또는 SMS 등을 “후원회원”에게 발송합니다. 다만,
        “후원회원”이 정보 수신을 거부하는 경우 그러하지 않습니다.
      </li>
      <li>
        “후원회원”은 직전연도 소득에 대한 연말정산시 해당 연도에 귀속되는
        후원금에 대해 세액공제를 받을 수 있습니다. 다만, “위원회”는 “후원회원”이
        기부금 영수증 발급을 위하여 주민등록번호 13자리를 “위원회”에 제공한
        경우에 한하여 국세청 간소화 서비스 등록 대행 업무를 수행합니다.
      </li>
      <li>
        “위원회”는 다음 각 호의 1의 경우 서비스에 대한 책임을 지지 않습니다.
        <DecimalList>
          <li>
            천재지변, 전쟁 및 기타 이에 준하는 불가항력으로 인하여 책임을 다할
            수 없는 경우
          </li>
          <li>“후원회원”의 귀책사유로 인하여 불이익 또는 손해가 발생한 경우</li>
          <li>
            기타 “위원회”의 귀책사유 없이 손해가 발생하였다고 판단되는 경우
          </li>
        </DecimalList>
      </li>
    </RoundDecimalList>
    <br />
    <br />
    <strong>제12조 (후원의 해지)</strong>
    <br />
    <br />
    <RoundDecimalList>
      <li>
        “후원회원”이 “후원” 해지를 원하는 경우 본인 또는 법적 대리인이 직접
        “위원회”가 운영하는 웹페이지, 전자메일(donor@unicef.or.kr) 또는 ‘위원회’
        전화(02-737-1004)를 통하여 “위원회”에 해지 요청을 하여야 합니다.
      </li>
      <li>
        “위원회”는 “후원” 해지 신청시 “후원회원” 본인임을 확인한 후 해지를
        처리해 드립니다. 이때 “위원회”는 “후원회원” 또는 법적 대리인에게
        개인정보, 관련 서류 등을 요청할 수 있습니다.
      </li>
      <li>
        후원 해지 후 각종 증명서 발급 등에 필요한 일부 개인정보는 회원관리
        업무를 위해 관련법령 및 본 약관 등에 의거하여 보유합니다. 다만,
        “후원회원”이 개인정보 삭제를 요청할 경우 등록된 개인정보를 폐기하며,
        개인정보 폐기 후에는 각종 증명서 발급 등의 회원관리 서비스를 지원하지
        않습니다.
      </li>
    </RoundDecimalList>
    <br />
    <br />
    <strong>제13조 (후원금의 반납)</strong>
    <br />
    <br />
    <RoundDecimalList>
      <li>
        “후원회원”이 “위원회”에 제공한 “기부재산”은 법령상 근거가 있는 등
        예외적인 경우를 제외하고는 일체 반환되지 않습니다.
      </li>
      <li>
        후원금 환불 시 증여세 등 비용이 발생하는 경우 이는 환불을 청구한 회원의
        부담으로 합니다.
      </li>
    </RoundDecimalList>
    <br />
    <br />
    <strong>제14조 (약관의 해석 등)</strong>
    <br />
    <br />
    <RoundDecimalList>
      <li>
        본 약관은 고액후원, 유산기부, 사회공헌협약 등 개별 후원약정이 있는 경우
        본 약관에 앞서 적용됩니다.
      </li>
      <li>
        본 약관에 명시되지 아니한 사항 및 그 해석에 관하여 관계법령 또는
        상관례에 따릅니다.
      </li>
    </RoundDecimalList>
    <br />
    <br />
    <strong>제15조 (분쟁의 해결)</strong>
    <br />
    <br />
    <RoundDecimalList>
      <li>
        “위원회”와 “후원회원” 간에 “후원” 및 관련된 사항에 관하여 분쟁이 발생한
        경우 상호 원만한 소통을 통해 해결하기 위하여 최선을 노력을 기울여야
        합니다.
      </li>
      <li>
        제1항에 따라 분쟁이 우호적으로 해결되지 않아 소송이 제기되는 경우 법령의
        절차에 따른 법원을 관할 법원으로 합니다.
      </li>
    </RoundDecimalList>
    <br />
    <br />
  </>
);

// 영문후원 개인정보 약관
export const EnglishPrivacyPolicyContent = (
  <div
    css={`
      > h4 {
        margin-top: 20px;
      }
      p {
        margin: 10px 0;
      }
    `}
  >
    <h3>
      The Korean Committee for UNICEF (“we/our/us”) places priority on the
      protection of our donators’ personal information. These Guidelines explain
      how we collect and use such personal information through our website. By
      visiting our website, you agree to accept the terms of these Guidelines.
    </h3>

    <h4>
      1. Personal information items collected by us and methods used by us for
      collection
    </h4>
    <div>
      <p>
        We collect the following personal information items for provision of our
        service.
      </p>
    </div>
    <div>
      <LowerRomanList>
        <li>
          Items collected: names, email addresses, credit card numbers and their
          validity
        </li>
        <li>
          Methods used for the collection of personal information items:
          homepage, customer center, and other services provided by us
        </li>
      </LowerRomanList>
    </div>

    <h4>2. Purpose of collecting and using personal information</h4>
    <div>
      <p>
        We collect and use personal information for the following: donation
        payment/management/consulting, emergency relief, donation encouragement,
        personal identification for provision of newsletters and (customized)
        services, prevention of fraudulent or unauthorized use of services,
        handling of complaints, dispatch of notices, etc.
      </p>
    </div>

    <h4>3. Period of retaining and using personal information</h4>
    <div>
      <p>
        We destroy personal information upon attaining the purpose of collecting
        and using personal information. However, we are required to keep certain
        information as follows for a given period under the law:
      </p>
    </div>
    <div>
      <RoundDecimalList>
        <li>
          Records about price payment and supply of goods: 5 years (per the Act
          on the Consumer Protection in the Electronic Commerce Transactions,
          etc.)
        </li>
        <li>
          Records about users’ complaint or handling of disputes: 3 years (per
          the Act on the Consumer Protection in the Electronic Commerce
          Transactions, etc.)
        </li>
      </RoundDecimalList>
    </div>

    <h4>4. Procedure and method of destroying personal information</h4>
    <div>
      <p>We destroy personal information collected by us as follows:</p>
    </div>
    <RoundDecimalList>
      <li>
        Procedure of destruction
        <LowerRomanList>
          <li>
            We destroy personal information collected by us immediately upon
            attaining the purpose of keeping it or at the end of the period set
            to keep it in a separate database as required by the law.
          </li>
          <li>
            We do not use the personal information kept in a separate database
            for a purpose other than required by the law.
          </li>
        </LowerRomanList>
      </li>
      <li>
        Method of destruction
        <LowerRomanList>
          <li>
            Paper printouts containing personal information: Destroyed with a
            shredder
          </li>
          <li>
            Electronic files containing personal information: Destroyed in a
            non-recoverable way
          </li>
        </LowerRomanList>
      </li>
    </RoundDecimalList>
    <div />

    <h4>5. Sharing and providing personal information</h4>
    <div>
      <p>
        We use users’ personal information within the extent that we informed
        them. We do not share or provide users’ personal information with/to a
        third party without their prior consent, unless one of the following is
        the case:
      </p>
    </div>
    <div>
      <RoundDecimalList>
        <li>When obtained prior consent from the user</li>
        <li>
          Where it is clearly difficult to obtain users’ consent due to an
          economic or technical reason concerning personal information required
          to carry out a contract associated with the provision of service
        </li>
        <li>
          Where there is a request from a law enforcement agency under the law
        </li>
        <li>Where it is objectively judged that disclosure of the personal</li>
        <li>
          information is necessary to take a legal step against a person
          violating our terms and conditions of using our service or doing harm
          to others or disturbing established social morals and good customs,
          using our service.
        </li>
      </RoundDecimalList>
    </div>

    <h4>6. Entrustment of personal information handling</h4>
    <div>
      <p>
        Where we need to entrust the handling of users’ personal information for
        efficiency, we provide users with information on the trustee and the
        content of business entrusted as follows.
      </p>
    </div>
    <Table
      border="0"
      cellPadding="0"
      cellSpacing="0"
      summary="개인정보의 취급위탁 업체에 대한 표이며 위탁대상자,제공항목,위탁업무내용순으로 나열하고 있습니다."
    >
      <thead>
        <tr>
          <th>Trustee</th>
          <th>Content of business entrusted</th>
          <th>Period of entrustment</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Metanet MCC Co., Ltd.</td>
          <td>Customer consulting, service operation</td>
          <td>Throughout the period of consulting and complaint handling</td>
        </tr>
        <tr>
          <td>DAOU Tech., INC.</td>
          <td>Dispatch of emails, messages, faxes</td>
          <td>Up to 45 days after dispatch</td>
        </tr>
        <tr>
          <td>KG INICIS Co., Ltd. and card businesses affiliated with it</td>
          <td>Donation payment handling</td>
          <td>Donation payment handling</td>
        </tr>
      </tbody>
    </Table>

    <h4>
      7. Operation of devices for automatic collection of personal information;
      matters about rejection of the use of such devices
    </h4>
    <div>
      <p>
        We use cookies to store and retrieve users’ personal information from
        time to time. Cookies are stored in users’ computers in the form of
        special text files to help users use our homepage more conveniently and
        for more efficient communication with visitors to our homepage.
      </p>
    </div>
    <RoundDecimalList>
      <li>
        We use cookies for the following purposes.
        <LowerRomanList>
          <li>
            Provision of customized service based on information on users’
            propensity and interests through the analysis of users’ connected
            pages and frequency/timing of visits.
          </li>
          <li>
            We use information collected through cookies only for our service
            and communication. We do not mix information collected through
            cookies with other data related to individuals’ real names in our
            data analysis.
          </li>
        </LowerRomanList>
      </li>
      <li>
        Users may reject our installation of cookies concerning their personal
        information on each occasion or outright. However, such rejection may
        lead to a difficulty in using our service.
      </li>
    </RoundDecimalList>

    <h4>8. Designation of Personal Information Manager</h4>
    <RoundDecimalList>
      <li>
        We designate a personal information manager etc. as follows to handle
        users’ complaints about the handling of personal information and their
        inquiries.
        <Table
          summary="개인정보 관리담당자에 대한 표이며 이름,소속,관리정보,연락처 순으로 나열하고 있습니다."
          className="sm_tbl"
        >
          <thead>
            <tr>
              <th>Category</th>
              <th>Name</th>
              <th>Position</th>
              <th>Contact point</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td rowSpan="2">Privacy officer</td>
              <td>Hye-young Hwang</td>
              <td>Director | Planning &amp; Administration</td>
              <td rowSpan="2">
                02-737-1004
                <br />
                privacy@unicef.or.kr
              </td>
            </tr>
            <tr>
              <td>Kim Dae-gong</td>
              <td>Manager | Information Security</td>
            </tr>
          </tbody>
        </Table>
      </li>
      <li>
        Inquiries may be made to the following agencies concerning personal
        information-related report or consulting.
        <LowerRomanList>
          <li>
            Korea Internet &amp; Security Agency (KISA)
            (https://www.kisa.or.kr/eng/main.jsp)
          </li>
          <li>
            Cybercrime Investigation Division of the Supreme Prosecutors' Office
            (http://www.spo.go.kr/eng/index.jsp)
          </li>
          <li>
            Korean National Police Agency Cyber Bureau
            (http://cyberbureau.police.go.kr/eng/index.do)
          </li>
        </LowerRomanList>
      </li>
    </RoundDecimalList>

    <h4>9. Matters for ensuring personal information-related safety</h4>
    <RoundDecimalList>
      <li>
        Technical/administrative steps taken for the protection of personal
        information: We take technical/administrative steps for the protection
        of personal (e.g. prevention of loss, theft, disclosure, alteration,
        etc.) in handling users’ personal information.
      </li>
      <li>
        Measures against hacking, etc.: We do our best to prevent users’
        personal information from being disclosed or damaged due to hacking or
        computer viruses. We back up coded data from time to time against a
        possibility of damaged personal information, prevent users’ personal
        information from being disclosed or damaged using updated vaccine
        programs, and use secure socket layer (SSL) for safe transmission of
        personal information through networks. We operate an Intrusion
        Prevention System (IPS) to block an attempt for unauthorized access to
        our system and strive to be equipped with all technical devices to
        ensure tight security.
      </li>
      <li>
        We keep the number of employees handling personal information to a
        minimum, change passwords for personal information periodically, educate
        employees from time to time, and remind them of the importance of
        observing the law pertaining to personal information protection
      </li>
      <li>
        We hold a meeting for personal information protection to ensure that
        these Guidelines are observed strictly.
      </li>
      <li>
        Please be informed that these Guidelines are not applied to personal
        information collected by websites linked to our site and that we are not
        responsible for any problems caused by the disclosure of personal
        information that includes credit card numbers or their validity
        resulting from users’ carelessness or a problem occurring on the
        Internet.
      </li>
    </RoundDecimalList>

    <h4>10. Additional rules</h4>
    <div>
      <p>These Guidelines shall be implemented on December , 2017</p>
    </div>
  </div>
);

export const AutoPaymentAgreeContent = (
  <>
    <br />
    <strong>금융거래정보의 제공 동의</strong>
    <br />
    <br />
    <DecimalList>
      <li>
        &ldquo;금융실명거래 및 비밀보장에 관한 법률&rdquo;의 규정에 따라,
        후원자는 본 신청과 관련하여 다음 금융거래정보를 청구기관(청구기관의 결제
        대행업체를 포함: 신용카드사와 결제대행사를 의미함)에 제공하는 것에
        동의합니다.
        <br />- 거래 카드사(은행)명
        <br />- 카드번호
      </li>
      <li>
        상기 1의 후원자 동의는 후원자가 신용카드 등 정기결제를 신규 신청하는
        때로부터 해지 신청할 때까지 유효합니다.
      </li>
    </DecimalList>
    <br />
    <strong>신용카드 정기결제 약관</strong>
    <br />
    <br />
    <RoundDecimalList>
      <li>
        후원자가 신청하신 신용카드 정기결제는 엔에이치엔케이씨피 주식회사(이하
        &ldquo;회사&rdquo;라 합니다)에서 대행하며, 이용자의 신용카드 결제
        내역에는 정기결제와 관련한 이용가맹점이 &lsquo;유니세프&rsquo;로
        표기됩니다.
      </li>
      <li>
        후원자는 앞면의 본인(카드소유주)이 납부하여야 할 후원금에 대하여 별도의
        통지 없이 본인의 카드정보를 사용하여 청구기관이 정한 지정 승인일(휴일인
        경우 익영업일)에 승인 납부하는데 이의가 없습니다.
      </li>
      <li>
        신용카드 등 정기결제를 위하여 지정카드번호로 승인하는 경우에는 회사가
        정한 지정카드의 유효성 인증 절차후 신용카드이용약관이나 약정서에 규정된
        안심클릭 혹은 ISP인증 등의 절차없이 결제가 진행됩니다.
      </li>
      <li>
        신용카드 등 정기결제 승인한도가 지정 출금일 현재 청구기관의 청구금액보다
        부족하거나, 신용카드의 사용정지 또는 신용카드 대금의 연체 등으로 대체
        청구가 불가능한 경우의 손해는 후원자가 부담합니다.
      </li>
      <li>
        신용카드 등 정기결제 신규신청에 의한 승인개시일은 회사가
        청구기관으로부터 사전 통지받은 승인일입니다.
      </li>
      <li>
        신용카드 등 정기결제 신청에 의한 지정카드 번호에서의 승인은 청구기관의
        청구대로 승인키로 하며 승인금액에 이의가 있는 경우에는 본인과 청구기관이
        협의하여 조정합니다.
      </li>
      <li>
        회사는 후원자의 본 신청과 관련한 거래내역에 대한 별도 조회(URL등
        이용방법) 수단을 제공합니다.
      </li>
      <li>
        이 약관은 신청서를 청구기관에 직접 제출하여 신용카드 등 정기결제를
        신청한 경우에도 적용합니다.
      </li>
      <li>
        기타 본 약관에서 규정하지 않은 사항은 여신전문금융업법 등 관련법령,
        신용카드이용약관 및 회사의 일반약관을 따릅니다.
      </li>
    </RoundDecimalList>
  </>
);
